import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import TextDisclosure from './text-disclosure'
import ExternalDisclosure from './external-disclosure'
import NotFoundDisclosure from './not-found-disclosure'
import CheckboxDisclosure from './checkbox-disclosure'
import ScrollRequiredDisclosure from './scroll-required-disclosure/ScrollRequiredDisclosure'
import ChildrenModals from './children-modals'
import ChildDisclosure from './child-disclosure'

const chooseComponent = (type, child) => {
  if (child) {
    switch (type) {
      case 'text':
        return TextDisclosure
      case 'external':
      case 'file':
        return ExternalDisclosure
      case 'modal':
        return ChildDisclosure
      default:
        return ChildDisclosure
    }
  }

  switch (type) {
    case 'text':
      return TextDisclosure
    case 'external':
    case 'file':
      return ExternalDisclosure
    default:
      return TextDisclosure
  }
}

class FacadeDisclosure extends PureComponent {
  static propTypes = {
    disclosure: PropTypes.object,
    type: PropTypes.string,
    variables: PropTypes.object,
    name: PropTypes.string,
    id: PropTypes.string,
    validate: PropTypes.func,
    child: PropTypes.bool,
    className: PropTypes.string,
    showError: PropTypes.bool,
  }

  static defaultProps = {
    type: 'none',
    disclosure: null,
    variables: {},
    name: null,
    id: null,
    validate: () => {},
    child: false,
    className: null,
    showError: true,
  }

  renderCheckbox() {
    const { disclosure, validate, id, name, onChange } = this.props
    const checkboxProps = { uuid: disclosure.uuid, validate, id, name, onChange }

    return <CheckboxDisclosure {...checkboxProps}>{this.renderDisclosure()}</CheckboxDisclosure>
  }

  renderScrollRequired() {
    return (
      <ScrollRequiredDisclosure {...this.props}>{this.renderDisclosure()}</ScrollRequiredDisclosure>
    )
  }

  renderNotFound() {
    const { showError } = this.props
    return showError && <NotFoundDisclosure />
  }

  isValidDisclosure() {
    const { disclosure } = this.props

    return disclosure && chooseComponent(disclosure.contentType)
  }

  renderContent() {
    const { type, child } = this.props

    if (!this.isValidDisclosure()) {
      this.renderNotFound()
    }

    if (child) {
      return this.renderDisclosure()
    }

    switch (type) {
      case 'checkbox':
        return this.renderCheckbox()
      case 'scrollRequired':
        return this.renderScrollRequired()
      default:
        return this.renderDisclosure()
    }
  }

  renderDisclosure() {
    const { disclosure, variables, child, actions, className } = this.props

    if (!disclosure) {
      return this.renderNotFound()
    }

    const disclosureProps = { disclosure, variables, actions }
    const $disclosureComponent = chooseComponent(disclosure.contentType, child)

    if (this.isParentDisclosure()) {
      return (
        <>
          <$disclosureComponent {...disclosureProps} />
          <ChildrenModals {...disclosureProps} className={className} />
        </>
      )
    }
    return <$disclosureComponent {...disclosureProps} />
  }

  render() {
    const { className, child } = this.props

    if (child) {
      return <span className={className}>{this.renderContent()}</span>
    }
    return <div className={className}>{this.renderContent()}</div>
  }

  isParentDisclosure() {
    const { child, disclosure } = this.props

    return disclosure.contentType === 'text' && !child
  }
}

export default FacadeDisclosure
